import { gsap } from 'gsap';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { getElementFromEvent } from '../utils';
import { createApp } from 'vue';
import AuthMenu from '../vue/AuthMenu.vue';

export default class Menu {
	isOpen = false;
	isAnimating = false;

	constructor() {
		this.domparser = new DOMParser();

		this.el = document.querySelector('[data-menu]');
		this.toggleButton = this.el.querySelector('[data-menu-toggle]');
		this.menuWrapper = this.el.querySelector('[data-menu-nav-wrapper]');
		this.menuWrapperInner = this.el.querySelector('[data-menu-nav-wrapper-inner]');
		this.menu = this.el.querySelector('[data-menu-nav]');
		this.bg = this.el.querySelector('[data-menu-bg]');

		// Auth
		this.authVueComponent = createApp(AuthMenu);
		this.authVueComponent.mount(this.el.querySelector('[data-auth-menu]'));

		// Events
		this.toggleButton.addEventListener('click', this.toggle.bind(this));
		this.bg.addEventListener('click', this.close.bind(this));

		document.addEventListener('leave', this.close.bind(this));
		document.addEventListener('bless', (e) => {
			const page = this.domparser.parseFromString(e.detail.html, 'text/html');
			const menu = page.querySelector('[data-menu-nav]');
			document.querySelector('[data-menu-nav]').replaceWith(menu);
			this.menu = menu;
		});

		// Improve ux
		this.el.addEventListener('click', (e) => {
			const menuItem = getElementFromEvent(e, '.menu-item');

			if (!menuItem) {
				return;
			}

			this.el.querySelectorAll('.menu-item').forEach((item) => {
				item.classList.remove('active');
			});

			menuItem.classList.add('active');
		});
	}

	toggle() {
		this.isOpen ? this.close() : this.open();
	}

	open() {
		if (this.isAnimating) {
			return;
		}

		if (this.isOpen) {
			return;
		}

		this.el.classList.add('is-open');

		const tl = gsap.timeline({
			onStart: () => {
				disablePageScroll();
				this.isAnimating = true;
			},
			onComplete: () => {
				this.isAnimating = false;
				this.isOpen = true;
			},
		});

		tl.to(this.bg, {
			autoAlpha: 1,
			ease: 'none',
			duration: 0.3,
		});

		tl.to(
			this.menuWrapper,
			{
				autoAlpha: 1,
				ease: 'none',
				duration: 0.1,
			},
			'<'
		);

		tl.to(
			this.menuWrapper,
			{
				y: 0,
				ease: 'power2.out',
				duration: 0.5,
			},
			'<'
		);

		tl.to(
			this.menuWrapperInner,
			{
				opacity: 1,
				duration: 0.3,
				ease: 'none',
			},
			'>-0.3'
		);
	}

	close() {
		if (this.isAnimating) {
			return;
		}

		if (!this.isOpen) {
			return;
		}

		this.el.classList.remove('is-open');

		const tl = gsap.timeline({
			onStart: () => {
				enablePageScroll();
				this.isAnimating = true;
			},
			onComplete: () => {
				this.isAnimating = false;
				this.isOpen = false;
			},
		});

		tl.to(this.bg, {
			autoAlpha: 0,
			ease: 'none',
			duration: 0.3,
		});

		tl.to(
			this.menuWrapperInner,
			{
				opacity: 0,
				duration: 0.3,
				ease: 'none',
			},
			'<'
		);

		tl.to(
			this.menuWrapper,
			{
				y: '100%',
				ease: 'power2.out',
				duration: 0.5,
			},
			'>-0.2'
		);

		tl.to(
			this.menuWrapper,
			{
				autoAlpha: 0,
				ease: 'none',
				duration: 0.1,
			},
			'>-0.2'
		);
	}
}
